import {camelToSentence} from 'App/utils/string';

export const CurrencyOfRecordTooltipContent = (): string =>
  'Bulk tendering is only available for shipments with the same currency.';

export const ParcelShipmentsTooltipContent = (key: string): string =>
  `${camelToSentence(key)} is only available with parcel shipments.`;

export const NonParcelShipmentsTooltipContent = (key: string): string =>
  `${camelToSentence(key)} is not available with parcel shipments.`;
